import { render, staticRenderFns } from "./traceDetail.vue?vue&type=template&id=0281b1d5&scoped=true&"
import script from "./traceDetail.vue?vue&type=script&lang=js&"
export * from "./traceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281b1d5",
  null
  
)

export default component.exports